import React from "react";
import "./EngagedSection.scss";
import engagedPhoto from "./images/engaged.webp";
import engagedPhotoRings from "./images/rings.svg";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";

export default function RingsSection() {
  return (
    <div className="relative overflow-hidden p-block-12 bg-base engaged-section">
      <div className="container text-center">
        <img className="engaged-photo" src={engagedPhoto} alt="Maria and Krasimir" width="100%" height="auto"/>
        <OnScrollAnimationWrapper
          animation={"animation-slide-fade-in-down"}
          triggerOnce={false}
          classNameInitialState={`opacity-0 text-animation-slide-in`}
        >
          <div className="m-top-12 title font-heading text-primary">Ще бъдеш ли с нас на <br/><span className="font-body">06.06.26</span>г.?</div>       
        </OnScrollAnimationWrapper>
        <img className="engaged-photo-rings m-top-12" src={engagedPhotoRings} alt="rings" width="30%" height="auto"/>
        <div className="m-bottom-4">
          
        <a href="#confirm" className="confirm-btn confirm-btn-inverse">
                <i className="fa-solid fa-calendar-check m-right-1"></i>
                ПОТВЪРДИ <span className="hidden-xs-min">ПРИСЪСТВИЕ</span>
              </a>
        <div className="col-12 text-center text-bold m-top-1">
            до 05 Май, 2026г.
          </div>
        </div>
      </div>
    </div>
  );
}
